import { Chip } from "@heroui/react";
import { displaySku } from "../lib/display-sku";
import { formatIdr } from "../lib/format";
import { productPath } from "../lib/json-ld";
import type { Product } from "../lib/types";

export function ProductCard({ product }: { product: Product }) {
  const sku = displaySku(product);
  const inStock = (sku?.available ?? 0) > 0;

  return (
    <a
      href={productPath(product.slug)}
      className="pasar-stall group flex flex-col overflow-hidden rounded-2xl bg-content1 text-foreground no-underline"
      data-stall=""
    >
      <div className="pasar-weave h-28" aria-hidden="true" />
      <div className="flex flex-1 flex-col gap-2 px-4 py-4">
        <h2 className="text-base font-semibold leading-snug">{product.name}</h2>
        <p className="text-sm text-muted">{product.merchant.name}</p>
        <div className="mt-auto flex items-end justify-between gap-3 pt-2">
          <p className="pasar-price text-lg font-semibold">
            {sku ? formatIdr(sku.price) : "—"}
          </p>
          <Chip
            size="sm"
            color={inStock ? "success" : "danger"}
            variant="soft"
          >
            <Chip.Label>{inStock ? "Tersedia" : "Habis"}</Chip.Label>
          </Chip>
        </div>
      </div>
    </a>
  );
}
